import React, { useState, useEffect } from 'react';
import { Typography, Paper, Box, Table, TableBody, TableCell, TableHead, TableRow, Button } from '@mui/material';
import { invoicesService } from '@services/invoicesService';
import VisitPaymentPanel from '@components/payments/VisitPaymentPanel';

export default function ReceptionInvoicing() {
  const [invoices, setInvoices] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [paymentPanelInv, setPaymentPanelInv] = useState<{ visitId: string; invoiceId: string } | null>(null);

  useEffect(() => {
    invoicesService.list({ page: 1, pageSize: 25 })
      .then((d) => setInvoices(d?.items || []))
      .catch(() => setInvoices([]))
      .finally(() => setLoading(false));
  }, []);

  const handlePdf = async (id: string, number: string) => {
    try {
      const blob = await invoicesService.getPdfBlob(id);
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>Facturare</Typography>
      {loading ? (
        <Paper sx={{ p: 4 }}>Se încarcă...</Paper>
      ) : invoices.length === 0 ? (
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography color="text.secondary">Nicio factură</Typography>
        </Paper>
      ) : (
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nr.</TableCell>
                <TableCell>Client</TableCell>
                <TableCell>Total</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Acțiuni</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoices.map((inv) => (
                <TableRow key={inv.id}>
                  <TableCell>{inv.number}</TableCell>
                  <TableCell>{inv.client ? `${inv.client.firstName} ${inv.client.lastName}` : '-'}</TableCell>
                <TableCell>{(inv.amountCents / 100).toFixed(2)} RON</TableCell>
                <TableCell>{inv.status}</TableCell>
                <TableCell>
                    <Button size="small" onClick={() => handlePdf(inv.id, inv.number)}>
                      PDF
                    </Button>
                    {inv.visitId && inv.status !== 'paid' && (
                      <Button size="small" onClick={() => setPaymentPanelInv({ visitId: inv.visitId, invoiceId: inv.id })} sx={{ ml: 1 }}>
                        Plată
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}
      {paymentPanelInv && (
        <Paper sx={{ p: 2, mt: 2 }}>
          <VisitPaymentPanel
            visitId={paymentPanelInv.visitId}
            invoiceId={paymentPanelInv.invoiceId}
            onPaid={() => {
              setPaymentPanelInv(null);
              invoicesService.list({ page: 1, pageSize: 25 }).then((d) => setInvoices(d?.items || []));
            }}
          />
          <Button size="small" onClick={() => setPaymentPanelInv(null)} sx={{ mt: 1 }}>Închide</Button>
        </Paper>
      )}
    </Box>
  );
}
